import Store from 'store/store';

function replace(content, values) {
	if (!values || typeof content !== 'string') return content;
	return content.replace(/%([^% ]+)%/g, (full, value) => values[value.toLowerCase()] ?? full);
}

export function copy(key, replacements) {
	return replace(Store.get().appData?.copy?.baseCopy?.[key] || '', replacements);
}
export function a11yCopy(key, replacements) {
	return replace(Store.get().appData?.copy?.accessibilityCopy?.[key] || '', replacements);
}

export function pageName(page) {
	const appData = Store.get().appData;
	const name = appData?.pages?.[page]?.name || page;
	return copy(name) || copy(`$PAGE_${page?.toUpperCase()}`) || name;
}